import { render, staticRenderFns } from "./RejectManageModal.vue?vue&type=template&id=506b69d6&"
import script from "./RejectManageModal.vue?vue&type=script&lang=js&"
export * from "./RejectManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RejectManageModal.vue"
export default component.exports